import { render, staticRenderFns } from "./IncomeExpenses.vue?vue&type=template&id=92438b38&"
import script from "./IncomeExpenses.vue?vue&type=script&setup=true&lang=js&"
export * from "./IncomeExpenses.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports